import { render, staticRenderFns } from "./AtomDoughnutChartV2.vue?vue&type=template&id=18340836&scoped=true&"
import script from "./AtomDoughnutChartV2.vue?vue&type=script&lang=js&"
export * from "./AtomDoughnutChartV2.vue?vue&type=script&lang=js&"
import style0 from "./AtomDoughnutChartV2.vue?vue&type=style&index=0&id=18340836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18340836",
  null
  
)

export default component.exports